<template>
  <Navbar :title="'信息中心'" :rightBtn="true"></Navbar>
  <div class="tabs-box">
    <van-tabs v-model:active="activeTabs" sticky @click-tab="changeTabs">
      <van-tab
        v-for="item in tabs"
        :key="item"
        :title="item.title"
        :name="item.id"
      >
      </van-tab>
    </van-tabs>
  </div>
  <div class="serch-box">
    <van-search
      class="search"
      v-model="formSearch.searchContent"
      shape="round"
      placeholder="搜索"
      @search="onSubmit"
    />
    <van-button
      round
      block
      type="primary"
      class="serch-btn"
      size="small"
      @click="onSubmit"
      >搜索
    </van-button>
  </div>
  <div class="serch" style="padding: 10px 0">
    <div class="flex-item">
      <span
        class="serch-item"
        :class="{ 'serch-item-active': show2 }"
        @click="showPopup2"
        >请选择行政级别</span
      >
    </div>
    <div class="flex-item">
      <span
        class="serch-item"
        :class="{ 'serch-item-active': show1 }"
        @click="showPopup1"
        >请选择发文部门</span
      >
    </div>
  </div>
  <van-popup v-model:show="show1" round position="bottom">
    <div class="boxs">
      <p class="title">请选择发文部门</p>
      <div style="height: 200px; overflow: auto">
        <div class="field-ul">
          <div class="flex-tag-select-container" style="grid-template-columns: 1fr 1fr;">
            <div
              v-for="item in fieldList"
              :key="item.dispatch_name"
              class="flex-tag-select-item"
              :class="{ selected: item.checked }"
              @click="() => toggleItem(item)"
            >
              {{ item.dispatch_name }}
            </div>
          </div>
        </div>
      </div>
      <van-button @click="roundbtn2" class="roundbtn" round type="primary"
        >确定</van-button
      >
    </div>
  </van-popup>
  <van-popup v-model:show="show2" round position="bottom">
    <div class="boxs">
      <p class="title">请选择行政级别</p>
      <div style="height: 100px">
        <div class="field-ul">
          <div class="flex-tag-select-container">
            <div
              v-for="(item, i) in public"
              :key="item.level"
              class="flex-tag-select-item"
              :class="{ selected: item.checked }"
              @click="() => toggleItem2(item, item.level)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <van-button @click="roundbtn1" class="roundbtn" round type="primary"
        >确定</van-button
      >
    </div>
  </van-popup>
  <van-empty description="暂无数据" v-show="emptyShow" />
  <van-list
    v-model:loading="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="getData"
    ref="shou"
    v-if="!emptyShow"
    style="margin: 10px"
  >
    <div
      class="notice-item"
      v-for="record in list"
      :key="record"
      @click="goDetail(record)"
    >
      <div class="notice-item-content">
        <div class="notice-item-title">
          <div class="flex-item">
            <span class="level" v-if="record.level && record.level > 3"
                  >其他</span
                >
                <span
                  class="level"
                  v-else-if="record.level && record.level == 1"
                  >省</span
                >
                <span
                  class="level"
                  v-else-if="record.level && record.level == 2"
                  >市</span
                >
                <span
                  class="level"
                  v-else-if="record.level && record.level == 3"
                  >区县</span
                >
                <span class="level" v-else>国</span>
            {{ record.title }}
          </div>
        </div>
        <div class="policy-content">
          <div>{{ record.content }}</div>
        </div>
        <!-- <div class="policy-content" v-if="record.dispatch">
          <div>发文批号:{{ record.dispatch }}</div>
        </div> -->
      </div>
      <div class="policy-file-item-footer">
        <div class="flex-item" style="flex: 1">
          <div class="flex">
            <div class="policy-file-item-tags flex-item">
              <van-tag
              class="tag"
                style="
                  margin-right: 4px;
                  background: #d8f4f0;
                  border-radius: 4px 4px 4px 4px;
                  color: #000000;
                "
              >
                {{ record.dispatch_name }}
              </van-tag>
              <!-- <van-tag v-if="record.declare_id"> 资金扶持 </van-tag> -->
            </div>
            <div class="flex-item">发布时间:{{ record.prepareDate }}</div>
          </div>
          <div class="flex">
            <div class="flex-item">浏览量:{{ record.click_num }}</div>
            <div class="flex-item">收藏量:{{ record.favorite_num }}</div>
          </div>
        </div>

        <!-- <div> -->
          <div class="btn-boxs">
            <van-button
              class="btn-favorite"
              v-if="!record.favorite"
              @click.stop="doFav(record, true)"
            >
              <img
                class="icon-favorite"
                src="@/assets/images/icon_favorite_1@2x.png"
              />
              收藏
            </van-button>
            <van-button
              class="btn-favorite btn-favorite-active"
              v-else
              ref="noshou"
              @click.stop="doFav(record, false)"
            >
              <img
                class="icon-favorite"
                src="@/assets/images/icon_favorite_2@2x.png"
              />
              已收藏
            </van-button>
          </div>
          <!-- <div class="declare-btn-box" v-if="activeTabs == 'declare'">
            <van-button
              class="declare-btn"
              type="primary"
              v-if="record.statusView == '1'"
              @click.stop="declare(record)"
            >
              申报
            </van-button>
            <van-button
              class="declare-btn"
              type="primary"
              plain
              hairline
              v-else-if="record.statusView == '2'"
            >
              未开始
            </van-button>
            <van-button
              class="declare-btn"
              type="primary"
              plain
              hairline
              v-else-if="record.statusView == '0'"
              >已结束
            </van-button>
          </div> -->
        <!-- </div> -->
      </div>
    </div>
  </van-list>
  <backTop :top="300"></backTop>

  <div v-if="declareShow">
    <declare-model
      :show="declareShow"
      :list="declareList"
      @declareSelected="declareSelected"
      @closeDeclare="closeDeclare"
    ></declare-model>
  </div>
</template>
<script>
import {
  queryArticleSearch,
  dispatchDepartmentGetAll,
  getDispatchv3,
  getServiceProviderList,
  queryUserById,
  getInformation,
  addFavoritev3,
  cancelFavoritev3,
} from "@/api/home";
import Navbar from "@/components/Navbar.vue";
import Select from "@/components/Select.vue";
import Dates from "@/components/Date.vue";
import DeclareModel from "@/components/DeclareModel";
import { clickUrl, clickUrlToPhone } from "@/utils";
import store from "@/store";
import moment from "moment";
import backTop from '@/components/BackTop.vue'
import { getUserInfo, setUserInfo, setToken } from "@/utils/storage";

export default {
  name: "PolicyQuery",
  components: { Select, Dates, Navbar, DeclareModel,backTop },
  data() {
    return {
      activeTabs: "",
      tabs: [
        { title: "申报通知", id: "declare" },
        { title: "立项公示", id: "policy" },
        { title: "其他", id: "notify" },
      ],
      searchTpt: [
        {
          type: "select",
          label: "发文部门",
          placeholder: "请选择发文部门",
          form: "dispatchDepartment",
          optionName: "name",
          optionValue: "id",
          name: "dispatchDepartment",
          options: [],
        },
        // {
        //   type: 'select', label: "发文类别", placeholder: "请选择发文类别", form: "proj_id", table: "proj", tableForm: {},
        //   optionName: "name", optionValue: "id", name: "proj_name",options:[]
        // },
      ],
      formSearch: {
        // daterange: [],
        // dispatchDepartment: '',
        // startTime: null,
        // endTime: null,
        searchContent: "",
        level: "",
        dispatch_name: "",
      },
      list: [],
      clickSearch: false,
      loading: false,
      finished: false,
      emptyShow: false,
      codeNum: null,
      declareShow: false,
      declareList: [],
      company: {},
      page: {
        count: 0,
        size: 20,
        total: 0,
      },
      departmentList: [],
      showPicker: false,
      title: "",
      show1: false,
      show2: false,
      fieldList: [
        // { id:'1', name: '发改',value: '',checked: false },
        // { id:'2', name: '经信',value: '',checked: false },
        // { id:'3', name: '科技',value: '',checked: false },
        // { id:'4', name: '综合办',value: '',checked: false },
        // { id:'5', name: '综合办',value: '',checked: false },
        // { id:'6', name: '科技',value: '',checked: false },
        // { id:'7', name: '经信',value: '',checked: false },
        // { id:'8', name: '发改',value: '',checked: false },
      ],
      public: [
        { level: "0", name: "国", value: "", checked: false },
        { level: "1", name: "省", value: "", checked: false },
        { level: "2", name: "市", value: "", checked: false },
        { level: "3", name: "区县", value: "", checked: false },
      ],
      type: 1,
      record: {},
      favFlag: false,
      refs: "",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    moment,
    showPopup1() {
      // this.show1 = !this.show1;
      var that = this
      this.getbumen(function () {
        that.show1 = true
      })
    },
    // async getbumen() {
    //   console.log(this.activeTabs);
    //   if (this.activeTabs == "declare") {
    //     let res = await getDispatchv3({ type: 1 });
    //     console.log(res);
    //     this.fieldList = res.result;
    //   } else if (this.activeTabs == "policy") {
    //     let res = await getDispatchv3({ type: 2 });
    //     console.log(res);
    //     this.fieldList = res.result;
    //   } else if (this.activeTabs == "notify") {
    //     let res = await getDispatchv3({ type: 0 });
    //     console.log(res);
    //     this.fieldList = res.result;
    //   }
    // },
    async getbumen(callback) {
      console.log(this.activeTabs,this.formSearch.level);
      let params = {}
      if (this.formSearch.level != '') {
        params.level = this.formSearch.level
      }
      if (this.activeTabs == "declare") {
        params.type = 1
      } else if (this.activeTabs == "policy") {
        params.type = 2
      } else if (this.activeTabs == "notify") {
        params.type = 0
      }
      try {
        let res = await getDispatchv3(params);
        console.log(res);
        let dispatch_name = this.formSearch.dispatch_name
        this.fieldList = res.result.filter(o => o.dispatch_name).map(item => {
          return {
            ...item,
            checked:
            item.dispatch_name == dispatch_name ? !item.checked : false,
          }
        });
        if (callback) {
          callback()
        }
      } catch {
        
      }
    },
    showPopup2() {
      this.show2 = !this.show2;
    },
    toggleItem(val) {
      this.fieldList = this.fieldList.map((item) => {
        return {
          ...item,
          checked:
            item.dispatch_name == val.dispatch_name ? !item.checked : false,
        };
      });
    },
    toggleItem2(item, level) {
      this.public = this.public.map((item) => {
        return {
          ...item,
          checked: item.level == level ? !item.checked : false,
        };
      });
    },
    roundbtn2() {
      this.reset();
      var arr = this.fieldList.filter((o) => o.checked) || [];
      this.formSearch.dispatch_name = arr.length ? arr[0].dispatch_name : "";
      this.getData();
      this.show1 = false;
    },
    roundbtn1() {
      this.reset();
      var arr = this.public.filter((o) => o.checked) || [];
      this.formSearch.level = arr.length ? arr[0].level : "";
      this.formSearch.dispatch_name = ''
      this.getData();
      this.show2 = false;
    },
    async doFav(record, type) {
      console.log(record);
      console.log(type);
      if (this.favFlag) {
        return false;
      }
      this.favFlag = true;
      const request = type ? addFavoritev3 : cancelFavoritev3;
      let res = await request({ article_id: record.id });
      this.$toast.success({
        message: type ? "收藏成功" : "取消收藏成功",
        duration: 2000,
      });
      setTimeout(() => {
         this.favFlag = false
                record.favorite=!record.favorite
                if( record.favorite){
                  record.favorite_num+=1
                }else{
                   record.favorite_num-=1
                }
      }, 2000);
    },
    init() {
      if (this.$route.query.userInfo) {
        this.userInfo = JSON.parse(this.$route.query.userInfo);
        setToken(this.userInfo.token);
        setUserInfo(this.userInfo);
      }
      this.codeNum = new Date().getTime();
      this.activeTabs = this.$route.query.type || "declare";
      // this.getdispatchDepartment()
      // this.getbumen();
      this.getDeclareList();
      // this.getCompany()
    },
    handle() {
      this.clickSearch = !this.clickSearch;
    },
    changeTabs(val) {
      console.log(val.name);
      this.activeTabs = val.name;
      this.reset(1);
      // this.getdispatchDepartment()
      // this.getbumen();
      this.getData();
    },
    reset(type) {
      if (type) {
        this.formSearch = {
          // dispatchDepartment: null,
          // dispatchDepartmentId: '',
          // startTime: null,
          // endTime: null,
          searchContent: "",
          dispatch_name: "",
          level: "",
        };
        this.codeNum = new Date().getTime();
        this.public = this.public.map((item) => {
          return {
            ...item,
            checked: false,
          };
        });
        this.fieldList = []
      }
      this.clickSearch = false;
      this.list = [];
      this.page.count = 0;
    },
    onSubmit() {
      this.page.count = 0;
      this.list = [];
      this.getData();
    },
    async getData() {
      var that = this;
      this.page.count += 1;
      this.loading = true;
      if (this.activeTabs == "policy") {
        this.type = 2;
      } else if (this.activeTabs == "declare") {
        this.type = 1;
      } else {
        this.type = 0;
      }
      let { searchContent, dispatch_name, level } = this.formSearch;
      let params = {
        type: this.type,
        // level:this.level,
        // dispatch_name: this.dispatch_name,
        // keywords: searchContent,
        page: this.page.count,
        pageSize: this.page.size,
      };
      if (dispatch_name) {
        params.dispatch_name = dispatch_name;
      }
      if (level) {
        params.level = level;
      }
      if (searchContent) {
        params.keywords = searchContent;
      }
      try {
        let res = await getInformation(params);
        let list =
          res.result.data.map((item) => {
             let arr = []
          if (item.dispatch_name) arr.push(item.dispatch_name)
          if(item.declare_type==1){

           arr.push('资质办理')
         }else if(item.declare_type==0){
          arr.push('资金申报')
         }
            item.statusView = -1;
            let nowTime = new Date().getTime();
            let startTime = item.start_time
              ? moment(item.start_time).toDate().getTime()
              : "";
            let endTime = item.end_time
              ? moment(item.end_time).toDate().getTime()
              : "";
            if (endTime && nowTime >= endTime) {
              item.statusView = 0;
            } else if (startTime && nowTime < startTime) {
              item.statusView = 2;
            } else if (startTime && nowTime >= startTime) {
              item.statusView = 1;
            }

            return {
              ...item,
              content: item.description ? that.getText(item.description) : "",
              prepareDate: item.time
                ? moment(item.time).format("YYYY-MM-DD")
                : "",
              releaseDate: item.create_time
                ? moment(item.create_time).format("YYYY-MM-DD")
                : "",
              statusView: item.statusView,
            };
          }) || [];
        this.list = this.list.concat(list);
        console.log(this.list);
        this.page.total = res.result.total;
        this.finished =
          this.list.length >= res.result.total && res.result.total != 0
            ? true
            : false;
        this.emptyShow = !res.result.total ? true : false;
      } catch {
      } finally {
        this.loading = false;
      }
      if (this.activeTabs == "declare") {
        this.title = "政策申报";
        this.dispatch_name = "";
        this.level = "";
      } else if (this.activeTabs == "policy") {
        this.title = "政策文件";
        this.dispatch_name = "";
        this.level = "";
      } else if (this.activeTabs == "notify") {
        this.title = "通知/公告";
        this.dispatch_name = "";
        this.level = "";
      }
    },
    goDetail(item) {
      let query = {
        btnType: "0",
        articleId: item.id,
        declare_id: item.declare_id,
        id: item.declare_id,
      };
      clickUrl("/article/detail", query);
      // if(item.declare_id){
      //   query.btnType = '1'
      //   query.id = item.declare_id
      //   clickUrl('/declare/detail', query)
      // }else if(item.policy_id){
      //   query.id = item.policy_id
      //   clickUrl('/policy/detail', query)
      // }else{
      //   query.id = item.notify_id
      //   clickUrl('/notify/detail', query)
      // }

      // clickUrl('/detail', query)
    },
    // async getdispatchDepartment() {
    //   let res = await dispatchDepartmentGetAll({type: this.activeTabs})
    //   this.departmentList = res.result.map(item=>{
    //     return item.dispatch_name
    //   }) || []
    //   // this.searchTpt = this.searchTpt.map(o => {
    //   //   if (o.name == 'dispatchDepartment') {
    //   //     o.options = result
    //   //   }
    //   //   return o
    //   // })
    // },
    onConfirm(val) {
      this.formSearch.dispatchDepartment = val;
      this.showPicker = false;
    },
    async getDeclareList() {
      let res = await getServiceProviderList({ type: "policy_declare_flag" });
      this.declareList = res.result.data ? res.result.data : [];
    },
    async getCompany() {
      let res = await queryUserById({ userId: this.userId });
      this.company = res.data ? res.data : {};
    },
    declare(item) {
      this.declareInfo = item;
      this.declareShow = true;
    },
    declareSelected(arg) {
      console.log(arg);
      this.declareShow = false;
      let query = {
        type: "getPhone",
        declare_id: this.declareInfo.id,
        serviceProviderId: arg.id,
        // companyName: this.company.companyName ? this.company.companyName : '',
        // policyId: this.declareInfo.id,
        // serviceProviderId: arg.id,
        // userId: this.userId,
        // company: JSON.stringify(this.company),
        // phone: this.company.phone ? this.company.phone : "",
      };
      clickUrlToPhone("", query);
    },
    closeDeclare() {
      this.declareShow = false;
    },
    getText(str) {
      let words = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, ""); //这里是去除标签
      return words.replace(/\s/g, ""); //这里是去除空格
    },
  },
  beforeRouteEnter(to, from, next) {
    // 进来的时候添加缓存组件 name
    // 此时不能使用this.$store.commit 因为组件还没有被创建所以不能使用this
    store.commit("ADD_KEEP_ALIVE_COM", "PolicyQuery");
    next();
  },
  beforeRouteLeave(to, from, next) {
    // 离开的时候，非以下页面则删除缓存组件 name
    // 记录路由处的name值 (去往详情展示页面需要添加缓存)
    let coms = [
      "NotifyDetail",
      "DeclareDetail",
      "PolicyDetail",
      "ArticleDetail",
    ];
    console.log(coms.indexOf(to.name) === -1, to.name);
    if (coms.indexOf(to.name) === -1) {
      store.commit("REMOVE_KEEP_ALIVE_COM", "PolicyQuery");
    }
    next();
  },
};
</script>
<style lang="scss">
.policy-file-item {
  & {
    margin: 10px;
    background: #fff;
  }

  &-content {
    padding: 15px;
  }

  &-title {
    font-weight: bold;
    margin-bottom: 8px;
  }

  &-tags {
    display: flex;
    flex-wrap: wrap;
  }

  &-tags > * {
    margin-bottom: 8px;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    // border-top: 1px solid #eee;
    border-top: 0;
    padding: 8px 15px;
    color: #aaa;
  }

  &-footer > view {
    font-size: 12px;
  }
}

.togger-box {
  margin-bottom: 20px;

  .van-cell__value--alone {
    text-align: center;
    color: #1989fa;
  }
}
</style>
<style lang="scss" scoped>
.policy-file-item-title {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  .declare-btn-box {
    flex-shrink: 0;
    width: 60px;
    text-align: right;
    white-space: nowrap;
    font-size: 12px;
  }
}
.tabs-box {
  position: fixed;
  top: 46px;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 10;
}
.search {
  margin-top: 44px;
  width: 80%;
}
.serch-box {
  padding: 0 15px;
  display: flex;
  background-color: #fff;
}
.serch-btn {
  margin-top: 55px !important;
  width: 20% !important;
}
.serch {
  background-color: #fff;
  text-align: center;
  display: flex;
  justify-content: space-around;
}
.serch-item {
  color: #35b2f2;
  position: relative;
  padding: 8px;
  &:after {
    position: absolute;
    top: 50%;
    right: -4px;
    margin-top: -5px;
    border: 3px solid;
    border-color: transparent transparent currentColor currentColor;
    transform: rotate(-45deg);
    opacity: 0.8;
    content: "";
  }

  &-active:after {
    margin-top: -1px;
    transform: rotate(135deg);
  }
}
.field-ul {
  margin: 0 20px;
  display: flex;
  flex-wrap: wrap;
}
.flex-tag-select-container {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  box-sizing: border-box;
  z-index: 10;
  /* overflow: auto; */
}
.title {
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 16px;
  text-align: center;
  background-color: #f2f2f2;
  margin-top: 0px;
  height: 30px;
  line-height: 30px;
}
.flex-tag-select-item {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  min-height: 30px;
  border: 1px solid #fff;
  box-sizing: border-box;
  background: rgba(231, 231, 231, 0.4);
  border-radius: 4px;
}
.flex-tag-select-item.selected {
  border: 1px solid #1989fa;
  color: #fff;
  background: #1989fa;
}
.roundbtn {
  height: 40px !important;
  background-color: #02a7f0;
  color: #fff;
  width: 100%;
  margin: 20px auto !important;
  display: block;
}
.notice-item {
  & {
    margin: 12px 3px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 1px rgba(128, 107, 78, 0.15);
    border-radius: 8px;
  }

  &-title {
    padding: 7px;
    font-weight: 550;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    background: linear-gradient(180deg, #e6f5ff 0%, #cfecff 100%);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .policy-content {
    padding: 5px 7px 0;
  }

  &-tags {
    display: flex;
    flex-wrap: wrap;
  }

  &-tags > * {
    margin-bottom: 8px;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    color: #666;
    font-size: 12px;
    padding: 10px 7px 10px;
  }

  &-footer > flex {
    justify-content: space-between;
  }
}
.notice-item-novip {
  filter: blur(4px);
}
.notice-item-title {
  display: flex !important;
  justify-content: space-around;
}
.notice-item-content {
  position: relative;
}
.novip-box {
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: center;
  text-align: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #666;
}
.flex-item {
  flex: 1;
}
.btn {
  width: 105px;
  height: 35px !important;
  line-height: 30px;
  background: linear-gradient(180deg, #fff4e0 0%, #fbcb89 100%);
  box-shadow: 0px 4px 4px 1px rgba(180, 164, 123, 0.25);
  border-radius: 20px;
  border: 0;
  font-size: 12px;
  font-weight: 600;
  color: #ff5019;
  white-space: nowrap;
  margin-top: 5px;
}
.btn-boxs {
  width: 73px;
  height: 30px;
  margin-left: 12px;
  .btn-favorite {
    width: 100%;
    height: 30px;
    line-height: 35px;
    background: #24caa4;
    border: 1px solid transparent;
    color: #fff;
    border-radius: 30px;
    padding: 0 !important;
    text-align: center;
    .icon-favorite {
      height: 15px;
      background-size: cover;
      vertical-align: middle;
      margin-top: -4px;
    }
    &-active {
      background: linear-gradient(90deg, #ff7019 0%, #fe8f1a 100%);
    }
    &-dis {
      background: rgba(85, 138, 126, 0.2);
    }
  }
}
.van-button--primary {
  width: 85%;
  margin-left: 0.32rem;
  background: #1989fa;
  border-radius: 14px 14px 14px 14px;
  opacity: 1;
  margin-top: 4px;
}
.policy-file-item-tags {
  line-height: 24px;
  padding-top: 4px;
}
.tag {
  width: 80px;
  padding: 0 3px;
  border-radius: 4px;
  font-weight: 400;
  margin-right: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;

  &.tag_0 {
    background: rgba(216, 244, 240, 0.5);
    border: 1px solid rgba(51, 151, 139, 0.8);
    color: #33978b;
  }

  &.tag_1 {
    background: rgba(139, 184, 213, 0.15);
    border: 1px solid #8bb8d5;
    color: #8bb8d5;
  }
}
.level {
  height: 16px;
  font-size: 12px;
  font-weight: 400;
  padding: 3px;
  background: #1989fa;
  color: #fff;
  border-radius: 4px;
}
</style>
